var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMealMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3705 11.5229L17.7096 8.61627C15.3972 4.56971 14.241 2.54644 12.5 2.54645C10.7591 2.54646 9.60293 4.56976 7.29063 8.61635L5.62974 11.523C3.3485 15.5152 2.20788 17.5113 3.07501 19.0055C3.94214 20.4998 6.24117 20.4998 10.8392 20.4998H14.1611C18.7592 20.4998 21.0583 20.4998 21.9254 19.0055C22.7925 17.5113 21.6518 15.5152 19.3705 11.5229Z",
    fill: "#CF8329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 13.8677V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.947368,
    cy: 0.947368,
    r: 0.947368,
    transform: "matrix(-1 0 0 1 13.447 15.7627)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealMissed);
export default __webpack_public_path__ + "static/media/mealMissed.d7ce55b81d227b1f36d50d856da58ec1.svg";
export { ForwardRef as ReactComponent };